<template>
  <section class="n-section-primary"
  :style="`background-color: var(--c-${vars.backgroundColor});`"> 
  <div
   
    
   
  >
    <div v-html="vars.titleHtml" ></div>
    
    <div>
      <library-form v-if="form" :form="form" version="v2" :component="component"></library-form>
    </div>
  </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'FormCard',

  mixins: [ComponentMixin],

  data() {
    return {
      form: null,
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.cardForm);
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
